import PropTypes from 'prop-types'
import rotateIcon from '../../../../icons/tabler-icon-rotate.svg'
import {StyledBox, StyledButton, StyledFocusDiv} from './Styles'

const FocusToState = ({onClick}) => {
  const FocusToStateText = 'Focus to state'
  return (
    <StyledBox>
      <StyledFocusDiv>
        <StyledButton onClick={onClick} title={FocusToStateText}>
          <img src={rotateIcon} alt='Focus to selected state(s)' width='18' height='18' />
        </StyledButton>
      </StyledFocusDiv>
    </StyledBox>
  )
}

FocusToState.propTypes = {
  onClick: PropTypes.func
}

export default FocusToState
